import AxiosInstance from 'utils/AxiosInstance'
import axios from 'axios'
import {
  BASE_URL_API as baseUrl,
  ACCESS_TOKEN as accessToken,
} from 'utils/helpers'
import * as types from './types'
import moment from 'moment'
import { isTextEmpty } from 'utils/helpers'
import { setMessagesFetched } from 'store/Dashboard/actions'

export const handleToggleModal = (modal) => {
  return (dispatch) => {
    if (modal === false) {
      dispatch(resetSelectedItems())
      dispatch(setPublic('public'))
      dispatch(
        setCurrentTab(
          null,
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups'
        )
      )
      dispatch(setAssignSearchValue(''))
    }
    dispatch({
      type: types.TOGGLE_MODAL,
      payload: modal,
    })
  }
}

export const markAsWelcome = (welcomeMessage) => ({
  type: types.MARK_AS_WELCOME,
  welcomeMessage,
})
export const onDateChange = (date) => ({ type: types.EXPIRATION_DATE, date })

export const setAssignSearchValue = (assignSearchValue) => ({
  type: types.SET_ASSIGN_SEARCH_VALUE,
  assignSearchValue,
})
export const setPublic = (value) => ({ type: types.SET_FILE_SCOPE, value })
export const resetSelectedItems = () => ({ type: types.RESET_SELECTED_ITEMS })

export const setShowSelectedOrgGroups = () => ({
  type: types.SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: true,
})
export const setHideSelectedOrgGroups = () => ({
  type: types.SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: false,
})
export const isLoading = (type, loadingType, isLoading) => ({
  type,
  loadingType,
  isLoading,
})
export const setShowSelectedUsers = () => ({
  type: types.SET_SHOW_SELECTED_USERS,
  showSelectedUsers: true,
})
export const setHideSelectedUsers = () => ({
  type: types.SET_SHOW_SELECTED_USERS,
  showSelectedUsers: false,
})

export const setShowSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: true,
})
export const setHideSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: false,
})

export const setShowSelectedLocationGroups = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: true,
})
export const setHideSelectedLocationGroups = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: false,
})

export const setShowSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: true,
})
export const setHideSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: false,
})

export const setShowSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: true,
})
export const setHideSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: false,
})

export const setIsReqLoading = (payload) => ({
  type: types.IS_REQ_LOADING,
  isReqLoading: payload,
})

export const setCurrentTab = (
  event,
  currentTab,
  currentSelectedItems,
  currentItems,
  currentToggleFunction,
  currentShowSelectedItems,
  currentShowSelectedItemsFunction,
  currentHideSelectedItemsFunction
) => {
  return (dispatch) => {
    if (event !== null) {
      event.preventDefault()
    }
    dispatch({ type: types.SET_CURRENT_TAB, currentTab })
    dispatch({ type: types.SET_CURRENT_SELECTED_ITEMS, currentSelectedItems })
    dispatch({ type: types.SET_CURRENT_ITEMS, currentItems })
    dispatch({
      type: types.SET_CURRENT_TOGGLE_ITEM_FUNCTION,
      currentToggleFunction,
    })
    dispatch({
      type: types.SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
      currentHideSelectedItemsFunction,
    })
    dispatch({
      type: types.SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
      currentShowSelectedItemsFunction,
    })
    dispatch({
      type: types.SET_CURRENT_SHOW_SELECTED_ITEMS,
      currentShowSelectedItems,
    })
  }
}

export const toggle = () => {
  return (dispatch, getState) => {
    const { isShowing, toggleModal } = getState().commboard
    dispatch({ type: types.TOGGLE_OVERLAY, isShowing: !isShowing })
    dispatch(handleToggleModal(!toggleModal))
  }
}

export const toggleMessage = (message) => {
  return (dispatch, getState) => {
    const { isShowingMessage, toggleModal } = getState().commboard
    dispatch({
      type: types.TOGGLE_MESSAGE_OVERLAY,
      isShowingMessage: !isShowingMessage,
      message,
    })
    dispatch(handleToggleModal(!toggleModal))
  }
}

export const toggleEditMessage = (id, message, expirationDate) => {
  return (dispatch, getState) => {
    const { isShowingEditMessage, messages, toggleModal } = getState().commboard
    dispatch(handleToggleModal(!toggleModal))
    dispatch({
      type: types.TOGGLE_EDIT_MESSAGE_OVERLAY,
      isShowingEditMessage: !isShowingEditMessage,
      id,
      message,
      expirationDate,
    })
    dispatch(fetchAssignees(id))
    const currentMessage = messages.find((item) => item.id === id)
    if (currentMessage) {
      dispatch(setPublic(currentMessage.scope))
    }
  }
}

// export const connect = () => {
// 	return (dispatch, getState) => {
// 		const { connected } = getState().commboard

// 		if (connected) {
// 			return
// 		}

// 		socket.on(`${process.env.CLIENT_ID}:message`, (message) => {
// 			// const { messages } = getState().commboard

// 			// dispatch({type: types.MESSAGE, data: [ message, ...messages]})
// 			dispatch(fetchMessages())
// 		})

// 		socket.on(`${process.env.CLIENT_ID}:delete`, (message) => {
// 			const { messages } = getState().commboard

// 			dispatch({
// 				type: types.MESSAGE,
// 				data: messages.filter((item) => item.id != message.id),
// 			})
// 		})

// 		dispatch({ type: types.CONNECTED })
// 	}
// }

export const all = () => {
  return (dispatch, getState) => {
    const { messages } = getState().commboard

    if (messages.length) {
      return
    }

    AxiosInstance.get('/notifications').then((data) => {
      if (data && Array.isArray(data)) {
        dispatch({ type: types.MESSAGE, data })
      }

      dispatch(isLoading(types.LOADING, 'notificationsLoaded', true))
    })
  }
}

export const onDelete = (id) => {
  return (dispatch, getState) => {
    const { messages } = getState().commboard

    dispatch({
      type: types.MESSAGE,
      data: messages.filter((item) => item.id !== id),
    })

    AxiosInstance.delete(`/notifications/${id}`)
  }
}

export const onSubmit = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const {
      isReqLoading,
      expirationDate,
      body,
      messages,
      welcomeMessage,
      selectedOrgGroups,
      selectedLocationGroups,
      selectedLocations,
      selectedRoles,
      selectedUsers,
      selectedStores,
      scope,
    } = getState().commboard

    if (isReqLoading) {
      return
    }

    if (isTextEmpty(body)) {
      alert('Please enter a message')
      return
    }

    dispatch(setIsReqLoading(true))

    const data = {
      expiration_date: moment(expirationDate).isValid() ? expirationDate : null,
      data: JSON.stringify({ message: body }),
      groups: [...selectedOrgGroups, ...selectedLocationGroups],
      users: selectedUsers,
      stores: selectedStores,
      roles: selectedRoles,
      scope,
      type: !messages.length && welcomeMessage ? 1 : 2,
    }

    // old version
    // axios.post(baseUrl() + '/notifications')

    AxiosInstance.post(`/notifications`, data).finally(() => {
      dispatch(toggle())
      dispatch(fetchMessages())
      dispatch(setMessagesFetched(false))
      dispatch({ type: types.ON_CHANGE, name: 'body', value: '' })
      dispatch(isLoading(types.LOADING, 'notificationsLoaded', true))
      dispatch(markAsWelcome(false))
      dispatch(setIsReqLoading(false))
    })
  }
}

export const onSubmitEditMessage = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const {
      expirationDate,
      message,
      id,
      selectedOrgGroups,
      selectedLocationGroups,
      selectedLocations,
      selectedRoles,
      selectedUsers,
      selectedStores,
      scope,
      toggleModal,
    } = getState().commboard

    if (!message) {
      return
    }

    const data = {
      expiration_date: moment(expirationDate).isValid() ? expirationDate : null,
      data: JSON.stringify({ message }),
      groups: [...selectedOrgGroups, ...selectedLocationGroups],
      users: selectedUsers,
      stores: selectedStores,
      roles: selectedRoles,
      scope,
    }

    // old version
    // axios.put(baseUrl() + `...`)

    AxiosInstance.put(`/notifications/${id}?token=${accessToken()}`, data).then(
      () => {
        dispatch(fetchMessages())
        dispatch(toggleEditMessage(id))
        dispatch({ type: types.EXPIRATION_DATE, date: null })
        dispatch({ type: types.ON_CHANGE, name: 'body', value: '' })
        dispatch(isLoading(types.LOADING, 'notificationsLoaded', true))
        dispatch(markAsWelcome(false))
        dispatch(handleToggleModal(!toggleModal))
      }
    )
  }
}

export const fetchMessages = () => async (dispatch, getState) => {
  dispatch({ type: types.LOADED, payload: true })
  AxiosInstance.get('/notifications')
    .then((data) => {
      if (data && Array.isArray(data)) {
        dispatch({ type: types.MESSAGE, data })
      }
      dispatch(setMessagesFetched(true))
    })
    .finally(() => {
      dispatch({ type: types.LOADED, payload: false })
    })
}

// export const onChange = (event) => {
// 	return (dispatch) => {
// 		const name = event.target.name
// 		const value = event.target.value
// 		dispatch({type: types.ON_CHANGE, name: name, value })
// 	}
// }

export const onChange = (value) => async (dispatch) => {
  dispatch({ type: types.ON_CHANGE, name: 'body', value })
}

export const onChangeEditMessage = (value) => {
  return (dispatch) => {
    dispatch({ type: types.ON_CHANGE_MESSAGE, message: value })
  }
}

// export const onChangeEditMessage = (event) => {
// 	return (dispatch) => {
// 		const name = event.target.name
// 		const value = event.target.value

// 		dispatch({ type: types.ON_CHANGE_MESSAGE, message: value })
// 	}
// }

export const markAsRead = (readIndex) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null
    alert(language.alerts ? language.alerts.view_message_not_implemented : null)

    const { messages } = getState().commboard

    dispatch({
      type: types.MESSAGE,
      data: messages.filter((item, index) => index !== readIndex),
    })

    const id = messages.filter((item, index) => index === readIndex)[0].id

    AxiosInstance.post(`/notifications/${id}`)
  }
}

export const toggleOrgGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedOrgGroups } = getState().commboard

    const index = selectedOrgGroups.indexOf(id)

    let orgGroups = []

    if (index !== -1) {
      orgGroups = [
        ...selectedOrgGroups.slice(0, index),
        ...selectedOrgGroups.slice(index + 1),
      ]
    } else {
      orgGroups = [...selectedOrgGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups })
  }
}

export const toggleUsers = (id) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().commboard

    const index = selectedUsers.indexOf(id)

    let users = []

    if (index !== -1) {
      users = [
        ...selectedUsers.slice(0, index),
        ...selectedUsers.slice(index + 1),
      ]
    } else {
      users = [...selectedUsers, id]
    }

    dispatch({ type: types.SET_SELECTED_USERS, users })
  }
}

export const toggleLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedLocationGroups } = getState().commboard

    const index = selectedLocationGroups.indexOf(id)

    let locationGroups = []

    if (index !== -1) {
      locationGroups = [
        ...selectedLocationGroups.slice(0, index),
        ...selectedLocationGroups.slice(index + 1),
      ]
    } else {
      locationGroups = [...selectedLocationGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_LOCATION_GROUPS, locationGroups })
  }
}

export const toggleLocations = (id) => {
  return (dispatch, getState) => {
    const { selectedLocations } = getState().commboard

    const index = selectedLocations.indexOf(id)

    let locations = []

    if (index !== -1) {
      locations = [
        ...selectedLocations.slice(0, index),
        ...selectedLocations.slice(index + 1),
      ]
    } else {
      locations = [...selectedLocations, id]
    }

    dispatch({ type: types.SET_SELECTED_LOCATIONS, locations })
  }
}

export const toggleStores = (id) => {
  return (dispatch, getState) => {
    const { selectedStores } = getState().commboard

    const index = selectedStores.indexOf(id)

    let stores = []

    if (index !== -1) {
      stores = [
        ...selectedStores.slice(0, index),
        ...selectedStores.slice(index + 1),
      ]
    } else {
      stores = [...selectedStores, id]
    }

    dispatch({ type: types.SET_SELECTED_STORES, stores })
  }
}

export const toggleRoles = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().commboard

    const index = selectedRoles.indexOf(id)

    let roles = []

    if (index !== -1) {
      roles = [
        ...selectedRoles.slice(0, index),
        ...selectedRoles.slice(index + 1),
      ]
    } else {
      roles = [...selectedRoles, id]
    }

    dispatch({ type: types.SET_SELECTED_ROLES, roles })
  }
}

export const fetchAssignees = (id) => {
  return (dispatch, getState) => {
    const { groups } = getState().groups

    const orgGroups = []
    const locationGroups = []
    const locations = []
    const stores = []
    const users = []
    const roles = []
    AxiosInstance.get(`/module-assignees/notification/${id}/assignees`).then(
      (data) => {
        if (data && data.length) {
          data.map((item) => {
            switch (item.assignee) {
              case 'group':
                const currentGroup = groups.find(
                  (groupItem) => groupItem.id === parseInt(item.assignee_id)
                )

                if (currentGroup && currentGroup.type === 'org') {
                  return orgGroups.push(parseInt(item.assignee_id))
                } else if (currentGroup && currentGroup.type === 'location') {
                  return locationGroups.push(parseInt(item.assignee_id))
                }

              case 'store':
                return stores.push(parseInt(item.assignee_id))
              case 'role':
                return roles.push(parseInt(item.assignee_id))
              case 'user':
                return users.push(item.assignee_id)
            }
          })

          dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups })
          dispatch({ type: types.SET_SELECTED_LOCATION_GROUPS, locationGroups })
          dispatch({ type: types.SET_SELECTED_LOCATIONS, locations })
          dispatch({ type: types.SET_SELECTED_USERS, users })
          dispatch({ type: types.SET_SELECTED_ROLES, roles })
          dispatch({ type: types.SET_SELECTED_STORES, stores })
        }
      }
    )
  }
}
